import { useMutation, useQueryClient } from '@tanstack/react-query'
import { editCompumaticPunch } from 'api/admin/timeClock/editCompumaticPunch'
import { timeClockKeys } from './keys'

export function useEditCompumaticPunchMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: editCompumaticPunch,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: timeClockKeys.all,
      })
    },
  })
}
